<template>
    <div class="flex flex-row w-full px-6 py-8 bg-blue-100 text-white rounded-lg">
        <div class="rounded-full bg-grey-200 w-20 h-20 sm:w-12 sm:h-12 block">
            <img src="@/assets/img/landing/review-Gustavo.png" alt="">
        </div>
        <div class="ml-5" v-if="account">
            <h1 class="text-white font-semibold text-xl" v-if="account.personalDetails"> {{account.personalDetails.name.firstName}} {{account.personalDetails.name.lastName}}</h1>
            <div class="text-white text-xs flex flex-col sm:flex-row">
                <span class="inline">
                    <span class="text-xs">No. de membresía {{ account.customerNumber }}</span>
                </span>
                <span class="inline ml-2 hidden sm:block">•</span>
                <span class="inline ml-0 sm:ml-2">
                    <span v-if="account.contactDetails">{{ account.contactDetails.emailAddress.email }} </span>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
export default {
    name : 'DashboardUserCardInformation',
    setup() {
        const store = useStore()
        const account = computed( () =>{
                return store.state.Accounts.data
            })
        

        return { account }
    },
}
</script>